import { ApChangeDetectionOptions } from '../interface';

export const DEFAULT_OPTIONS: ApChangeDetectionOptions = {
  detach: '_detach',
  detect: '_detect',
  properties: '_properties',
  reattach: '_reattach'
};
